<script setup lang="ts">
import { useField } from 'vee-validate';
import { onMounted, reactive, watch } from 'vue';

import { FieldValue, InvisibleFieldProps } from './InvisibleField.vue.d';
import { FieldValidation } from '../form/Form.vue.d';

const props = withDefaults(defineProps<InvisibleFieldProps>(), {
  value: undefined,
  fieldName: 'invisibleinput',
});

const field = reactive<FieldValidation<FieldValue>>({
  value: typeof props.value === 'string' ? props.value?.trim() : props.value,
});

onMounted(() => {
  Object.assign(field, useField(props.fieldName ?? 'invisibleinput'));

  if (props.value != null)
    field.value =
      typeof props.value === 'string' ? props.value?.trim() : props.value;
});

watch(
  () => props.value,
  (newValue) => {
    field.value = newValue;
  },
);
</script>

<template>
  <div class="!hidden" />
</template>
